module.exports = __webpack_public_path__ + "assets/favicon.png?e2d77127eb0b872007b3e80110ddadb2"